/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { LineItem } from "./LineItem";
export const SubscriptionUpdates = core.serialization.object({
    lineItems: core.serialization.list(LineItem),
});
